import { ComponentMap } from '@cinch-nx/data-storyblok'
import { landingStoryblokComponents } from '@cinch-nx/landing-ui-shared'
import { ComponentLayouts } from '@cinch-nx/storyblok-utils'

const { HighlightsSection, ...slimComponents }: ComponentMap = {
  ...landingStoryblokComponents,
}

export const servicingStoryblokComponents: ComponentLayouts = {
  fullWidthWrapper: { HighlightsSection },
  slimWrapper: slimComponents,
}
